import { getScaledFont } from '@wix/thunderbolt-becky-root'
import { textPaddingLimit } from '../../../components/ComboBoxInput/contants'
import type {
	ComboBoxInputNavigationBorderVars,
	ComboBoxInputNavigationCSSVars,
	CompInfo,
} from '@wix/thunderbolt-components-native'
import { getInputHeightInPx } from '../inputUtils'
import { getRequiredIndicationDisplay } from '../../carmi/InputUtils/InputUtils'

export const getComboBoxInputNavigationCSSVars = (
	// @ts-ignore - remove once siteFonts is added to CompInfo
	compInfo: Pick<CompInfo, 'compLayout' | 'styleProperties' | 'siteFonts' | 'isMobileView' | 'compProps'>,
	alignText: 'left' | 'center' | 'right',
	borders: ComboBoxInputNavigationBorderVars,
	isOneDocMigrated: boolean
): ComboBoxInputNavigationCSSVars => {
	const isRightAligned = alignText === 'right'
	const leftPadding = isRightAligned ? textPaddingLimit : 20
	const rightPadding = isRightAligned ? 20 : textPaddingLimit
	const { compProps, compLayout, styleProperties } = compInfo
	const { inputHeight, inputHeightMobile } = compProps
	return {
		'--dir': isRightAligned ? 'rtl' : 'ltr',
		'--arrowLeftPosition': isRightAligned ? '0' : 'auto',
		'--arrowRightPosition': isRightAligned ? 'auto' : '0',
		'--textAlign': alignText,
		'--textPadding': `0 ${rightPadding}px 0 ${leftPadding}px`,
		// @ts-ignore - remove once siteFonts is added to CompInfo
		'--fnt': getScaledFont(compInfo, 'fnt', isOneDocMigrated),
		'--inputHeight': getInputHeightInPx({
			inputHeight,
			inputHeightMobile,
			height: compLayout.height!,
			isMobileView: compInfo.isMobileView,
		}),
		'--requiredIndicationDisplay': getRequiredIndicationDisplay(styleProperties),
		'--borderColor': 'rgba(0, 0, 0, 0.2)',
		...borders,
	}
}
